export default __webpack_public_path__ + "static/media/4.dccfecc9.jpeg";